import graphql from "babel-plugin-relay/macro";

export const configContanceGeneralSettingsQuery = graphql`
  query queries_ConfigContanceGeneralSettingsQuery {
    configConstance {
      faqsUrl
      legalInfoUrl
      privacyUrl
    }
  }
`;
export const recipesPageQuery = graphql`
  query queries_RecipesPage_recipes_Query {
    allCategories {
      ...DropdownCategories_allCategories
    }
    allWarnings {
      ...StepRecipeModal_allWarnings
    }
    configConstance {
      ...StepRecipeModal_configConstance
    }
    allIngredients {
      ...IngredientRecipeModal_allIngredients
    }
    allUnitMeasure {
      ...IngredientRecipeModal_allUnitMeasure
    }

    allLabel {
      edges {
        node {
          id
          name
        }
      }
    }

    ...RecipesPage_allRecipes
  }
`;

export const ingredientsPageQuery = graphql`
  query queries_IngredientsPage_recipes_Query {
    allCategories {
      ...DropdownCategories_allCategories
    }
    ...IngredientsPage_allIngredients
  }
`;

export const allergensPageQuery = graphql`
  query queries_AllergensPage_recipes_Query {
    allCategories {
      ...DropdownCategories_allCategories
    }

    ...AllergensPage_allAllergen
  }
`;

export const categoriesPageQuery = graphql`
  query queries_CategoriesPage_recipes_Query {
    ...CategoriesPage_allCategories
  }
`;

export const unitsPageQuery = graphql`
  query queries_UnitsPage_recipes_Query {
    allCategories {
      ...DropdownCategories_allCategories
    }

    ...UnitsPage_allUnitMeasure
  }
`;

export const alertsPageQuery = graphql`
  query queries_AlertsPage_recipes_Query {
    allCategories {
      ...DropdownCategories_allCategories
    }

    ...AlertsPage_allWarnings
  }
`;
export const filtersPageQuery = graphql`
  query queries_FiltersPage_recipes_Query {
    allCategories {
      ...DropdownCategories_allCategories
    }

    ...FiltersPage_allLabelGroup
  }
`;

export const generalInfoPageQuery = graphql`
  query queries_GeneralInfoQuery {
    faqsContent {
      content
    }
    privacyContent {
      content
    }
    allCategories {
      ...DropdownCategories_allCategories
    }
    allWarnings {
      ...StepRecipeModal_allWarnings
    }
    configConstance {
      ...StepRecipeModal_configConstance
    }
    allIngredients {
      ...IngredientRecipeModal_allIngredients
    }
    allUnitMeasure {
      ...IngredientRecipeModal_allUnitMeasure
    }
  }
`;
export const categoriesListQuery = graphql`
  query queries_CategoriesListQuery($name: String) {
    allCategories(name: $name) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          name
          picture
        }
      }
    }
  }
`;

export const allergensListQuery = graphql`
  query queries_AllergensListQuery($name: String) {
    allAllergen(name: $name) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          icon
          name
        }
      }
    }
  }
`;

export const unitsListQuery = graphql`
  query queries_UnitsListQuery(
    $code: String
    $first: Int
    $orderBy: [String]
    $after: String
  ) {
    allUnitMeasure(
      code: $code
      first: $first
      orderBy: $orderBy
      after: $after
    ) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          description
          code
          id
        }
      }
    }
  }
`;

export const ingredientsListQuery = graphql`
  query queries_IngredientsListQuery($name: String) {
    allIngredients(name: $name) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;

export const recipesListQuery = graphql`
  query queries_RecipesListQuery(
    $name: String
    $first: Int
    $orderBy: [String]
    $category: ID
    $after: String
    $author: ID
    $publicDateFrom: String
    $publicDateTo: String
    $isTrend: Boolean
  ) {
    allRecipes(
      name: $name
      isTrend: $isTrend
      first: $first
      author: $author
      category: $category
      orderBy: $orderBy
      publicDateTo: $publicDateTo
      publicDateFrom: $publicDateFrom
      after: $after
    ) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        cursor
        node {
          id
          isTrend
          name
          category {
            id
            name
          }
          serves
          favoritedBy {
            edges {
              node {
                username
              }
            }
          }
          medRatings
          totalRatings
          published
          hotKeep
          picture
          difficulty
          mediaFiles {
            edges {
              node {
                mediaUrl
              }
            }
          }
        }
      }
    }
  }
`;

export const allWarnings = graphql`
  query queries_AllWarningsQuery(
    $slugName: String
    $orderBy: [String]
    $first: Int
    $after: String
  ) {
    allWarnings(
      slugName: $slugName
      orderBy: $orderBy
      first: $first
      after: $after
    ) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          slugName
          description
          icon
        }
      }
    }
  }
`;

export const recipeQuery = graphql`
  query queries_RecipeQuery($id: ID!) {
    ...SingleRecipePage_query @arguments(id: $id)
  }
`;
export const allAllergensQuery = graphql`
  query queries_AllergensQuery {
    allAllergen {
      edges {
        node {
          name
          id
          icon
        }
      }
    }
    allCategories {
      ...DropdownCategories_allCategories
    }
    # allRecipeWarning {
    #   ...StepRecipeModal_allRecipeWarning
    # }
    # configConstance {
    #   ...StepRecipeModal_configConstance
    # }
    # allIngredients {
    #   ...IngredientRecipeModal_allIngredients
    # }
    # allUnitMeasure {
    #   ...IngredientRecipeModal_allUnitMeasure
    # }
  }
`;
